




















































































import Vue, { PropType } from "vue";
import { Step } from "../../types/interface/stepper/step";
export default Vue.extend({
  props: {
    canContinue: {
      type: Boolean,
      default: true,
    },
    steps: {
      type: Array as PropType<Array<Step>>,
    },
    isFormChanged: {
      type: Boolean,
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    resumeStep: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      canContinueData: true,
      currentStep: {} as Step,
      previousStep: {} as Step,
      finalStep: false,
    };
  },
  methods: {
    isStepActive(index): string {
      if (this.currentStep.index === index) {
        return "activated";
      } else {
        return "deactivated";
      }
    },
    activateStep(index, back = false): void {
      if (this.steps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = this.steps[index];
        this.currentStep.index = index;

        if (index + 1 === this.steps.length) {
          this.finalStep = true;
        } else {
          this.finalStep = false;
        }
        if (!back) {
          this.previousStep.completed = true;
          this.$emit("completed-step", this.previousStep);
        }
      }
      this.$emit("active-step-changed", this.currentStep.index);
    },
    nextStepAction(): void {
      if (this.canContinueData) {
        if (this.finalStep) {
          this.$emit("stepper-finished", this.currentStep);
        }
        let currentIndex = this.currentStep.index! + 1;
        this.activateStep(currentIndex);
      }
      this.$forceUpdate();
    },
    nextStep(): void {
      if (!this.$listeners || !this.$listeners["before-next-step"]) {
        this.nextStepAction();
      }
      this.$emit(
        "before-next-step",
        { currentStep: this.currentStep },
        (next = true) => {
          this.canContinueData = true;
          if (next) {
            this.nextStepAction();
          }
        }
      );
    },
    cancelStepper(): void {
      this.$emit("cancel-stepper");
    },
    backStep(): void {
      this.$emit("clicking-back");
      if (this.currentStep.index) {
        let currentIndex = this.currentStep.index - 1;

        if (currentIndex >= 0) {
          this.activateStep(currentIndex, true);
        }
      }
    },
    init(): void {
      this.canContinueData = this.canContinue;
      if (this.resumeStep != null) {
        this.currentStep = this.steps[this.resumeStep];
        this.activateStep(this.resumeStep, true);
      } else {
        this.currentStep = this.steps[0];
        this.activateStep(0, true);
      }
    },
  },
  created() {
    this.init();
  },
  watch: {
    canContinue: {
      handler(value) {
        this.canContinueData = value;
      },
      deep: true,
    },
  },
});
